import UtilsService from './UtilsService';
import ApiService from './ApiService';
import AnalyticsService from './AnalyticsService';
import { trackError } from '../utils/error.utils';

export const leadCreated = async ({
    email,
    source,
    additionalData,
    leadType,
    reportToIterable = true
}: {
    email: string;
    source: string;
    additionalData?: Record<string, any>;
    leadType?: string;
    reportToIterable?: boolean;
}) => {
    const stableId = UtilsService.handleHBAnonymousId();
    const utms = UtilsService.getAllUtmParams();
    const referrer = document.referrer;

    try {
        ApiService.announceLeadCreated({
            email,
            stable_id: stableId,
            source,
            ...(Object.keys(utms || {}).length > 0 && { utms }),
            additional_data: {
                ...(referrer && { referrer }),
                ...additionalData,
                location: window.location.pathname
            }
        });

        if (reportToIterable) {
            AnalyticsService.reportIterableEvent(
                'lead_created',
                {
                    source,
                    email,
                    ...(leadType && { lead_type: leadType }),
                    ...additionalData
                },
                { email }
            );
        }
    } catch (error) {
        trackError(error, {
            message: 'failed to create lead',
            source,
            stable_id: stableId
        });
    }
};
